module.exports = __webpack_public_path__ + "static/biglogo-e5ce4e630f00d3a537ce90806cd7a851.png";